var _circle, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReloadIconActiveLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "url(#paint0_linear_127_5840)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0518 17.0285C27.7169 17.4677 27.8013 18.0952 28.2405 18.4301C29.9675 19.7471 31 21.787 31 24C31 27.4973 28.4352 30.3956 25.084 30.9166L25.7929 30.2071C26.1834 29.8166 26.1834 29.1834 25.7929 28.7929C25.4024 28.4024 24.7692 28.4024 24.3787 28.7929L21.8787 31.2929C21.4882 31.6834 21.4882 32.3166 21.8787 32.7071L24.3787 35.2071C24.7692 35.5976 25.4024 35.5976 25.7929 35.2071C26.1834 34.8166 26.1834 34.1834 25.7929 33.7929L24.9497 32.9505C29.4739 32.476 33 28.6498 33 24C33 21.1564 31.6712 18.5312 29.4533 16.8398C29.0142 16.5049 28.3867 16.5894 28.0518 17.0285ZM26.1213 15.2929L23.6213 12.7929C23.2308 12.4024 22.5976 12.4024 22.2071 12.7929C21.8466 13.1534 21.8189 13.7206 22.1239 14.1129L22.2071 14.2071L23.0503 15.0495C18.5261 15.524 15 19.3502 15 24C15 26.7198 16.2151 29.2432 18.2716 30.9419C18.6974 31.2936 19.3277 31.2335 19.6794 30.8077C20.0312 30.3819 19.9711 29.7516 19.5453 29.3999C17.944 28.0772 17 26.1168 17 24C17 20.5027 19.5648 17.6044 22.916 17.0834L22.2071 17.7929C21.8166 18.1834 21.8166 18.8166 22.2071 19.2071C22.5676 19.5676 23.1348 19.5953 23.5271 19.2903L23.6213 19.2071L26.1213 16.7071C26.4818 16.3466 26.5095 15.7794 26.2045 15.3871L26.1213 15.2929Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_127_5840",
    x1: 24,
    y1: 0,
    x2: 24,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28C9DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8957CF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReloadIconActiveLight);
export default __webpack_public_path__ + "static/media/reloadIconActiveLight.5189d0fc5b9dfcf07c719294c62a5b87.svg";
export { ForwardRef as ReactComponent };